import { string, number, mixed, array, object } from 'yup';
import {StatusCodes} from 'http-status-codes';

const AFBCUR = {
    heading: { maxWidth: '1100px', margin: 'auto', marginTop: '20px', fontSize: "40px", textAlign: "left", textDecoration: "none", color: 'rgb(6, 48, 63)' },
    para: { padding: "15px", paddingLeft: "50px" },
    image: { marginBottom: "5px" },
    holder: { backgroundColor: 'white', paddingTop: '30px' },
    textFieldStyle: { backgroundColor: '#fff' },
    battonBackGroundColor: { backgroundColor: '#fff', '&:disabled': { backgroundColor: '#ebcc13 !important', color: '#555' } },
    main: { maxWidth: '1100px', margin: 'auto' },
    paddingBottom: { paddingBottom: "30px" },
    inputItem: { width: "100%" },
    createUserSelect: { '& p': { maxWidth: "200px", textOverflow: "ellipsis", display: "inline-block", overflow: "hidden", whiteSpace: "nowrap !important" } },
    para1: { float: "right", paddingRight: "20px" }
};
const ERR_MESSAGE = "This field is required.";
const articleYup = {
    type: number().required(ERR_MESSAGE),
    category:mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    title: string().max(40, "max 40 charater").required(ERR_MESSAGE),
    isdeleted: number(),
    resourceid: string().required(ERR_MESSAGE),
    topicid: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    trigger: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE).typeError(ERR_MESSAGE),
    categorytag: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    topictag: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    diseasesegment: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    treatmentphase: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    drugcategory: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    persona: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    searchtags: string().required(ERR_MESSAGE).test('value', 'Remove last charater comma(,)', value=>value&&!(value.lastIndexOf(",")===value.length-1)),
    objective: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
};

const videoYupArticle = { videoUrl: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE).test("file", "File Size is greater than 25MB/Unsupported Format", value => value && !(value.includes("fakepath")))};
const articleContentYupGeneric = {
    publication: string().required(ERR_MESSAGE),
    readTime: string().required(ERR_MESSAGE),
    articleImage: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    contentBody: string().required(ERR_MESSAGE),
    mediaCaption: string().required(ERR_MESSAGE),
    shortDescription: string().max(250, "max 250 charater").required(ERR_MESSAGE),
    longDescription: string().max(StatusCodes.INTERNAL_SERVER_ERROR, "max 500 charater").required(ERR_MESSAGE),
};

const articleContentIf = {
    ...articleContentYupGeneric,
    ...videoYupArticle
};

const articleContentElse = {
    ...articleContentYupGeneric
};

export { AFBCUR, articleYup, articleContentIf, articleContentElse };